export default function loadingMoreCsr() {
  let page = 1
  
  document.getElementById('btn-more-csr').addEventListener('click', function () {
      const button = this
      const totalPosts = parseInt(document.getElementById('hid-found_posts').value)
      const currentCount = document.querySelectorAll('.csr__link').length
      const category = document.getElementById('hid-category').value
  
      button.disabled = true
      button.innerHTML = 'さらに表示する<span></span>'
  
      fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
              action: 'load_more_csr_posts',
              paged: ++page,
              category: category
          })
      })
      .then(response => response.text())
      .then(data => {
          const list = document.getElementById('csr__list')
          list.insertAdjacentHTML('beforeend', data)
          
          const newCount = document.querySelectorAll('.csr__link').length
          document.getElementById('post_num').textContent = newCount
  
          if (newCount >= totalPosts) {
              // button.style.display = 'none'
          } else {
              button.disabled = false
              button.innerHTML = 'さらに表示する<span></span>'
          }
      })
      .catch(err => {
          console.error(err)
          button.disabled = false
          button.innerHTML = 'さらに表示する<span></span>'
      })
  })
}
